export function encodeTrue(): void {
}

export function encodeFalse(): void {
}
